import type { AxiosInstance, AxiosResponse } from 'axios';

import type { RootResponse } from '@/models/rootResponse';
import type { Site } from '@/models/site';

export type GetSites = {
   search?: string;
};

class SiteService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getSites({ search }: GetSites): Promise<RootResponse<Site[]>> {
      const response: AxiosResponse<RootResponse<Site[]>> =
         await this.provider.post(`/sites/search`, {
            filters: [
               {
                  field: 'name',
                  operator: 'like',
                  value: `%${search}%`,
               },
            ],
            sort: [{ field: 'name', direction: 'asc' }],
            limit: '1000',
         });
      return response.data;
   }
}

export default SiteService;
